import i18n from '@/i18n'
import moment from 'moment-timezone'

const releaseDateText = 'February 25, 2022'

export const releaseDate = '2022-01-25 00:01:00'
export const releaseDateTimeZone = 'America/Vancouver'
export const deadlineDate = '2022-02-24 23:59:59'
export const deadlineTimeZone = 'America/Vancouver'

export default {
  data: function () {
    return {
      AJAS_SPONSORS: 'AJAS Sponsors',
      AJAS_SPONSORS_HASHTAG: 'AJASsponsors'
    }
  },
  computed: {
    studentProjectPendingMessage: function () {
      return i18n.t('explore.studentProjectPendingMessage')
    },
    willAppearOn: function () {
      return i18n.t('explore.willAppearOn')
    },
    ajasCategoryError: function () {
      if (this.$route.query.tag === this.AJAS_SPONSORS_HASHTAG) {
        return `${this.AJAS_SPONSORS} ${this.willAppearOn} ${releaseDateText}.`
      } else {
        return `${this.studentProjectPendingMessage}`
      }
    },
    isBeforeAjasReleaseDate: function () {
      return this.$isAjas && moment().isBefore(moment.tz(releaseDate, releaseDateTimeZone))
    },
    isAfterAjasReleaseDate: function () {
      return this.$isAjas && moment().isAfter(moment.tz(releaseDate, releaseDateTimeZone))
    }
  },
  methods: {
    ajasErrorMessages: function (title) {
      if (title === 'AJAS Sponsors') {
        return `${this.AJAS_SPONSORS} ${this.willAppearOn} ${releaseDate}.`
      } else {
        return `${this.studentProjectPendingMessage}`
      }
    }
  }
}
